import { CreateDocumentDto, CreateDocumentResponse } from "@/types/document";
import { BaseService } from "./BaseService";
import { IDocumentService } from "./interfaces/IDocumentService";

class DocumentService extends BaseService implements IDocumentService {
  private basePath = "/documents";

  constructor() {
    super();
  }

  async createDocument(
    createDocumentDto: CreateDocumentDto,
  ): Promise<CreateDocumentResponse> {
    return this.post<CreateDocumentResponse>(this.basePath, createDocumentDto);
  }
}

export const documentService = new DocumentService();
